import { Link } from "react-router-dom";
import LogoSvg from "./LogoSvg";
import { cn } from "@/lib/utils";

interface DashboardLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const DashboardLayout = ({ children, className }: DashboardLayoutProps) => (
  <div className="min-h-screen bg-white text-black">
    <header className="border-b border-black/10">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-6">
        <LogoSvg className="h-auto w-32" />
        <Link
          to="/blog"
          className="text-sm underline decoration-1 underline-offset-4 hover:text-[#d62600]"
        >
          Blog archive
        </Link>
      </div>
    </header>

    <main className={cn("mx-auto w-full max-w-5xl px-6 py-12", className)}>
      {children}
    </main>

    <footer className="mx-auto max-w-5xl border-t border-black/10 px-6 py-8 text-sm text-black/60">
      OpenPipe archive
    </footer>
  </div>
);

export default DashboardLayout;
